import { useMutation } from "@tanstack/react-query";
import {
  uploadLocationPhoto,
  deleteLocationPhoto,
  setLocationMainPhoto,
} from "@/api/queries/Locations";

export const useUploadLocationPhoto = () => {
  const mutation = useMutation({
    mutationFn: ({ id, file }: { id: string; file: File }) =>
      uploadLocationPhoto(id, file),
    // Remove onSuccess to prevent query invalidation
    // The component will handle the state update locally
  });

  return {
    triggerUploadPhoto: mutation.mutate,
    uploadPhotoAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};

export const useDeleteLocationPhoto = () => {
  const mutation = useMutation({
    mutationFn: ({ id, photoUrl }: { id: string; photoUrl: string }) =>
      deleteLocationPhoto(id, photoUrl),
    // Remove onSuccess to prevent query invalidation
    // The component will handle the state update locally
  });

  return {
    triggerDeletePhoto: mutation.mutate,
    deletePhotoAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};

export const useSetLocationMainPhoto = () => {
  const mutation = useMutation({
    mutationFn: ({ id, photoUrl }: { id: string; photoUrl: string }) =>
      setLocationMainPhoto(id, photoUrl),
    // Remove onSuccess to prevent query invalidation
    // The component will handle the state update locally
  });

  return {
    triggerSetMainPhoto: mutation.mutate,
    setMainPhotoAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
